import type { FC, PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { captureException } from '@sentry/react';

import { FatalError } from '../pages/fatal-error';

export type AppErrorBoundaryProps = PropsWithChildren;

export const AppErrorBoundary: FC<AppErrorBoundaryProps> = ({ children }) => (
  <ErrorBoundary
    FallbackComponent={FatalError}
    onError={(err, info) => captureException(err, { extra: { info } })}>
    {children}
  </ErrorBoundary>
);
